import React from 'react';
import { CreditCardIcon, CheckIcon } from 'lucide-react';
export const BillingSettings = () => {
  return <div data-id="element-1326">
      <div className="mb-6" data-id="element-1327">
        <h2 className="text-lg font-semibold" data-id="element-1328">Billing & Subscription</h2>
        <p className="text-gray-600" data-id="element-1329">
          Manage your subscription plan and payment methods
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6" data-id="element-1330">
        <div className="flex justify-between items-start" data-id="element-1331">
          <div data-id="element-1332">
            <h3 className="text-lg font-medium" data-id="element-1333">Current Plan</h3>
            <div className="mt-2" data-id="element-1334">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800" data-id="element-1335">
                Enterprise Plan
              </span>
              <p className="mt-1 text-gray-600" data-id="element-1336">Billed annually</p>
            </div>
          </div>
          <div className="text-right" data-id="element-1337">
            <p className="text-2xl font-bold" data-id="element-1338">
              $999
              <span className="text-lg font-normal text-gray-500" data-id="element-1339">/month</span>
            </p>
            <p className="text-sm text-gray-500" data-id="element-1340">
              Next billing on Oct 15, 2023
            </p>
          </div>
        </div>
        <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-1341">
          <h4 className="font-medium mb-3" data-id="element-1342">Plan Features</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1343">
            <div className="flex items-center" data-id="element-1344">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1345" />
              <span className="text-sm" data-id="element-1346">Unlimited AI Recruiters</span>
            </div>
            <div className="flex items-center" data-id="element-1347">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1348" />
              <span className="text-sm" data-id="element-1349">Unlimited Screenings</span>
            </div>
            <div className="flex items-center" data-id="element-1350">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1351" />
              <span className="text-sm" data-id="element-1352">Advanced Analytics</span>
            </div>
            <div className="flex items-center" data-id="element-1353">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1354" />
              <span className="text-sm" data-id="element-1355">Custom Integrations</span>
            </div>
            <div className="flex items-center" data-id="element-1356">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1357" />
              <span className="text-sm" data-id="element-1358">Dedicated Support</span>
            </div>
            <div className="flex items-center" data-id="element-1359">
              <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-1360" />
              <span className="text-sm" data-id="element-1361">Advanced Security</span>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-3" data-id="element-1362">
          <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-1363">
            Change Plan
          </button>
          <button className="px-4 py-2 border border-red-300 text-red-600 rounded-md hover:bg-red-50" data-id="element-1364">
            Cancel Subscription
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1365">
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1366">
          <h3 className="text-lg font-medium mb-4" data-id="element-1367">Payment Methods</h3>
          <div className="space-y-4" data-id="element-1368">
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1369">
              <div className="flex justify-between items-center" data-id="element-1370">
                <div className="flex items-center" data-id="element-1371">
                  <div className="w-10 h-10 bg-blue-100 rounded-md flex items-center justify-center mr-3" data-id="element-1372">
                    <CreditCardIcon size={20} className="text-blue-600" data-id="element-1373" />
                  </div>
                  <div data-id="element-1374">
                    <p className="font-medium" data-id="element-1375">Visa ending in 4242</p>
                    <p className="text-sm text-gray-500" data-id="element-1376">Expires 09/2025</p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-1377">
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full mr-2" data-id="element-1378">
                    Default
                  </span>
                  <button className="text-gray-500 hover:text-gray-700 text-sm" data-id="element-1379">
                    Edit
                  </button>
                </div>
              </div>
            </div>
            <button className="w-full py-2 border border-dashed border-gray-300 rounded-lg text-indigo-600 hover:bg-indigo-50 transition-colors" data-id="element-1380">
              + Add Payment Method
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1381">
          <h3 className="text-lg font-medium mb-4" data-id="element-1382">Billing History</h3>
          <div className="space-y-3" data-id="element-1383">
            {[{
            date: 'Sep 15, 2023',
            amount: '$999.00',
            status: 'Paid'
          }, {
            date: 'Aug 15, 2023',
            amount: '$999.00',
            status: 'Paid'
          }, {
            date: 'Jul 15, 2023',
            amount: '$999.00',
            status: 'Paid'
          }, {
            date: 'Jun 15, 2023',
            amount: '$999.00',
            status: 'Paid'
          }].map((invoice, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-1384">
                <div data-id="element-1385">
                  <p className="font-medium" data-id="element-1386">{invoice.date}</p>
                  <p className="text-sm text-gray-500" data-id="element-1387">
                    Invoice #INV-{2023090 + index}
                  </p>
                </div>
                <div className="text-right" data-id="element-1388">
                  <p className="font-medium" data-id="element-1389">{invoice.amount}</p>
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full" data-id="element-1390">
                    {invoice.status}
                  </span>
                </div>
              </div>)}
          </div>
          <div className="mt-4 flex justify-end" data-id="element-1391">
            <button className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1392">
              View All Invoices
            </button>
          </div>
        </div>
      </div>
    </div>;
};